import { useQuery } from '@tanstack/react-query'
import { billingApi, type GuildLimits } from './billingApi'

/** Уровень 0 — пока таблица не пришла; совпадает с backend/internal/billing/limits.go. */
const BASE: GuildLimits = { tier: 0, emojis: 50, stickers: 5, sounds: 8, bitrate_kbps: 96, upload_mb: 25, stream_height: 1080, stream_fps: 30 }

/**
 * Лимиты сервера по уровню бустов — из таблицы, которую отдаёт сервер (GET /billing/plans).
 * Раньше в настройках стояли числа нулевого уровня: «Стикеры — 2 из 5» и выключенная кнопка
 * загрузки на сервере третьего уровня, где можно 60 (правка №21).
 */
export function useGuildLimits(tier: number | undefined): GuildLimits {
  const q = useQuery({ queryKey: ['billing-showcase'], queryFn: billingApi.showcase, staleTime: 60 * 60_000 })
  return q.data?.tiers[Math.max(0, Math.min(3, tier ?? 0))] ?? BASE
}
